export default "__VITE_ASSET__ju0TbzGb__"